import React from 'react';
import { Helmet } from 'react-helmet-async';

// ==================== PAGE-SPECIFIC SEO CONFIGS ====================
// Enhanced SEO configuration for each page with keywords and structured data hints
// Defined first so it can be used by SEO component
export const PAGE_SEO = {
  home: {
    title: "Jamaica Driver's Guide - Road Traffic Act, Tax Office Fees & Driving Laws",
    description: "Jamaica's #1 driver's guide. Road Traffic Act fines, Tax Office licence & registration fees, police stop rights, traffic lawyers, insurance, speed cameras & road fatality tracker. Updated 2026.",
    keywords: 'Jamaica Road Traffic Act, tax office Jamaica, TAJ Jamaica, driving in Jamaica, Jamaica drivers guide, road traffic regulations Jamaica, Jamaica driving licence, tax office fees Jamaica, speeding fines Jamaica, traffic lawyer Jamaica, motor insurance Jamaica, demerit points Jamaica, police stop rights Jamaica, road code test Jamaica, ITA Jamaica, Island Traffic Authority, TRN Jamaica, certificate of fitness Jamaica, speed limit Jamaica, learner permit Jamaica, provisional driver licence Jamaica, pay traffic ticket online Jamaica, road tax Jamaica, international driving permit Jamaica, Jamaica crash today, examination depot Jamaica'
  },
  offences: {
    title: 'All 147 Traffic Offences & Fines Under Jamaica Road Traffic Act',
    description: 'Complete database of all 147 Jamaica traffic offences with fines and demerit points under the Road Traffic Act. Search speeding, DUI, seat belt, phone use, parking violations and more.',
    keywords: 'Jamaica traffic fines, speeding fine Jamaica, DUI Jamaica, traffic offences Jamaica, road traffic act fines, demerit points Jamaica, parking fines Jamaica, seat belt fine Jamaica, phone while driving Jamaica, road traffic violations Jamaica'
  },
  walkthrough: {
    title: 'What To Do When Stopped By Police in Jamaica - Your Rights',
    description: 'Step-by-step guide for what to do when stopped by police in Jamaica. Know your rights under the Road Traffic Act, required documents, and proper procedures during traffic stops.',
    keywords: 'police stop Jamaica, traffic stop rights Jamaica, what to do when stopped by police Jamaica, Jamaica driver rights, constitutional rights Jamaica, road traffic act rights'
  },
  lawyers: {
    title: 'Traffic Lawyers in Jamaica - All 14 Parishes',
    description: 'Find experienced traffic lawyers across all 14 parishes in Jamaica. Get legal help for speeding tickets, DUI charges, dangerous driving, and traffic court appearances.',
    keywords: 'traffic lawyer Jamaica, DUI lawyer Jamaica, speeding ticket attorney Jamaica, traffic court lawyer Jamaica, legal help Jamaica, road traffic act lawyer'
  },
  insurance: {
    title: 'Motor Insurance Companies in Jamaica - Compare & Get Quotes',
    description: 'Compare motor insurance companies in Jamaica. Find third-party (mandatory), comprehensive, and fleet coverage from top insurers across all parishes. Required under the Road Traffic Act.',
    keywords: 'motor insurance Jamaica, car insurance Jamaica, third party insurance Jamaica, comprehensive insurance Jamaica, vehicle insurance Jamaica, mandatory insurance road traffic act'
  },
  evaluators: {
    title: 'Vehicle Fitness Test Centers Jamaica - ITA Approved',
    description: 'Find authorized vehicle fitness test centers and evaluators across Jamaica. ITA official locations and approved private inspection services. Required annually for road licence.',
    keywords: 'vehicle fitness Jamaica, ITA fitness test, ITA examination depot Jamaica, vehicle inspection Jamaica, car fitness test Jamaica, motor vehicle examination Jamaica, certificate of fitness Jamaica, Island Traffic Authority depot locations, fitness test cost Jamaica'
  },
  services: {
    title: 'Auto Service Providers Directory Jamaica',
    description: 'Complete directory of traffic lawyers, insurance companies, vehicle evaluators, mechanics, parts dealers, wreckers, and auto service providers across all 14 parishes in Jamaica.',
    keywords: 'auto services Jamaica, mechanic Jamaica, car parts Jamaica, vehicle services Jamaica, automotive directory Jamaica, wrecker Jamaica, car repair Jamaica'
  },
  cameras: {
    title: 'Speed Camera Locations in Jamaica - Map & List',
    description: 'Map and list of all fixed and mobile speed camera locations across Jamaica. Community-verified speed enforcement zones to help you stay under the limit and avoid fines.',
    keywords: 'speed cameras Jamaica, traffic cameras Jamaica, speed traps Jamaica, camera locations Jamaica, traffic enforcement Jamaica, speeding Jamaica'
  },
  hotspots: {
    title: 'Police Checkpoints & Traffic Hotspots Jamaica - Live Updates',
    description: 'Community-reported police checkpoints, traffic hotspots, road blocks, and road conditions across Jamaica. Real-time updates from drivers island-wide.',
    keywords: 'police checkpoint Jamaica, traffic hotspot Jamaica, road block Jamaica, traffic updates Jamaica, checkpoint locations Jamaica, Jamaica road conditions'
  },
  learner: {
    title: "How To Get Your Jamaica Driver's Licence - Learner Guide",
    description: "Complete guide to getting your Jamaica driver's licence. Learner's permit requirements, written knowledge test, practical road test, Tax Office fees, and tips for passing your driving test.",
    keywords: "learner's permit Jamaica, provisional driver's licence Jamaica, driver's licence Jamaica, driving test Jamaica, how to get licence Jamaica, road code test Jamaica, road code test questions Jamaica, ITA examination depot Jamaica, Tax Office licence fee, Jamaica driving test questions, Class C licence Jamaica, PPV licence Jamaica"
  },
  fees: {
    title: "Tax Office Fees Jamaica - Driver's Licence, Registration & Road Tax",
    description: "Complete Tax Administration Jamaica (TAJ) fee schedule. Driver's licence ($4,500), learner's permit ($3,000), vehicle registration ($3,500), fitness test, road tax, and all other Tax Office motor vehicle fees. Updated 2026.",
    keywords: "tax office Jamaica fees, TAJ fees Jamaica, driver's licence fee Jamaica, vehicle registration fee Jamaica, road tax Jamaica, road tax renewal Jamaica, fitness test cost Jamaica, certificate of fitness Jamaica, tax office vehicle registration, tax office driver's licence, TRN Jamaica, Tax Administration Jamaica, learner's permit fee Jamaica, pay road tax online Jamaica"
  },
  demerit: {
    title: 'Demerit Points System Jamaica - Points Per Offence & Suspension Rules',
    description: "Complete guide to Jamaica's demerit point system under the Road Traffic Act. Points assigned for each offence, 10-point suspension threshold, accumulation rules, and how to check your balance.",
    keywords: 'demerit points Jamaica, licence suspension Jamaica, traffic points system Jamaica, how many points Jamaica, licence revocation Jamaica, road traffic act demerit points'
  },
  calculator: {
    title: 'Jamaica Traffic Fine Calculator - Calculate Your Fines',
    description: 'Calculate your total fines for traffic offences in Jamaica. Add multiple offences, see court costs, demerit points, and total payment due under the Road Traffic Act.',
    keywords: 'fine calculator Jamaica, traffic fine calculator Jamaica, how much is speeding fine Jamaica, calculate traffic fine Jamaica, Jamaica traffic ticket cost'
  },
  getlisted: {
    title: 'Get Your Business Listed - Jamaica Auto Services Directory',
    description: "Submit your business to be featured in Jamaica Driver's Guide. Traffic lawyers, insurance companies, mechanics, evaluators, parts dealers, and vehicle service providers across Jamaica.",
    keywords: 'list business Jamaica, advertise Jamaica, business directory Jamaica, service provider listing Jamaica, auto services advertising Jamaica'
  },
  'fatality-tracker': {
    title: 'Jamaica Road Fatality Tracker - Interactive Map & Statistics 2024-2026',
    description: 'Interactive map and statistics of road fatalities in Jamaica. View fatal crash hotspots by parish, monthly trends, victim demographics, and road safety data. Updated weekly. 374 deaths in 2025.',
    keywords: 'road fatalities Jamaica, traffic deaths Jamaica, road accidents Jamaica, Jamaica crash today, road safety statistics Jamaica, crash data Jamaica, Jamaica road deaths 2026, fatal accidents Jamaica map, road accident today Jamaica, Jamaica accident news'
  },
  askbot: {
    title: 'Jamaica Traffic Law Assistant - Ask About Fines & Road Traffic Act',
    description: 'Ask questions about Jamaica traffic laws and get instant answers. AI-powered assistant for Road Traffic Act regulations, fines, demerit points, and driver information.',
    keywords: 'traffic law help Jamaica, ask about fines Jamaica, road traffic act questions Jamaica, Jamaica traffic regulations assistant'
  },
  howto: {
    title: 'How-To Guides for Driving in Jamaica - Tax Office, Licence, Insurance',
    description: 'Step-by-step guides: register a vehicle at the Tax Office, renew your driver\'s licence, file an insurance claim, transfer vehicle ownership, and other essential procedures for driving in Jamaica.',
    keywords: 'how to register vehicle Jamaica, renew licence Jamaica Tax Office, insurance claim Jamaica, driver guides Jamaica, how to transfer vehicle ownership Jamaica'
  },
  roadcode: {
    title: 'Jamaica Road Code & Road Signs - Study Guide',
    description: 'Complete guide to Jamaica road signs, traffic signals, road markings, and the official road code. Study for your driving test. Regulatory, warning, and information signs explained.',
    keywords: 'Jamaica road signs, road code test Jamaica, road code test questions Jamaica, traffic signs Jamaica, road code Jamaica, driving rules Jamaica, traffic signals Jamaica, driving test study Jamaica, road markings Jamaica, speed limit Jamaica, right of way Jamaica, road code pass mark Jamaica'
  },
  'online-services': {
    title: 'Online Government Services for Drivers in Jamaica',
    description: 'Access online services from TAJ, ITA, and other agencies. Renew licence online, pay road tax, check fitness status, and other e-services for Jamaica drivers.',
    keywords: 'TAJ online services Jamaica, ITA online Jamaica, renew licence online Jamaica, road tax online Jamaica, e-services Jamaica drivers'
  },
  tickets: {
    title: 'Track Your Traffic Tickets Jamaica',
    description: 'Track and manage your Jamaica traffic tickets. Record ticket details, fine amounts, court dates, and payment status. Stay organized with your Road Traffic Act violations.',
    keywords: 'traffic ticket tracker Jamaica, pay traffic ticket online Jamaica, TAJ traffic ticket payment, manage traffic tickets Jamaica, traffic court Jamaica, fine payment Jamaica, TRN traffic ticket Jamaica'
  },
  accident: {
    title: 'What To Do After a Car Accident in Jamaica',
    description: 'Step-by-step guide for what to do after a motor vehicle accident in Jamaica. Insurance claims, police reports, documentation, and your rights under the Road Traffic Act.',
    keywords: 'car accident Jamaica, motor vehicle accident Jamaica, accident report Jamaica, insurance claim accident Jamaica, what to do after accident Jamaica'
  },
  'insurance-lookup': {
    title: 'Motor Insurance Lookup Jamaica - Verify Your Coverage',
    description: 'Look up and verify motor insurance coverage in Jamaica. Check if a vehicle is insured, compare policies, and find the right coverage under the Road Traffic Act requirements.',
    keywords: 'motor insurance lookup Jamaica, verify insurance Jamaica, check vehicle insurance Jamaica, insurance coverage Jamaica'
  },
  'privacy-policy': {
    title: 'Privacy Policy',
    description: "Jamaica Driver's Guide privacy policy. How we collect, use, and protect your personal information.",
    keywords: 'privacy policy Jamaica drivers guide'
  },
  'how-guide-works': {
    title: "How Jamaica Driver's Guide Works",
    description: "Learn how Jamaica Driver's Guide provides comprehensive Road Traffic Act information, Tax Office fees, traffic fines, and driver resources for Jamaica.",
    keywords: "how Jamaica driver's guide works, about Jamaica drivers guide"
  },
  contact: {
    title: "Contact Jamaica Driver's Guide",
    description: "Get in touch with Jamaica Driver's Guide. Questions about the Road Traffic Act, feedback, business inquiries, and support.",
    keywords: 'contact Jamaica drivers guide, feedback, support, business inquiries Jamaica'
  },
  login: {
    title: 'Sign In - Jamaica Driver\'s Guide',
    description: "Sign in to your Jamaica Driver's Guide account to access saved documents, track tickets, and manage your profile.",
    keywords: 'login Jamaica drivers guide, sign in, account access'
  },
  dashboard: {
    title: 'My Dashboard - Jamaica Driver\'s Guide',
    description: 'Manage your documents, track tickets, view analytics, and access all your personalized features.',
    keywords: 'dashboard, my account, document tracker, ticket management Jamaica'
  }
};

// ==================== SEO COMPONENT ====================
// Handles meta tags, Open Graph, Twitter cards, and structured data
export const SEO = ({
  title = "Jamaica Driver's Guide",
  description = "Jamaica's #1 driver's guide. Road Traffic Act fines, Tax Office licence & registration fees, police stop rights, traffic lawyers, insurance & road fatality tracker. Updated 2026.",
  keywords = '',
  page = 'home',
  canonical,
  image = '/og-image.png',
  type = 'website'
}) => {
  const siteName = "Jamaica Driver's Guide";
  const baseUrl = 'https://jamaicadriversguide.com';

  const fullTitle = page === 'home'
    ? `${siteName} | Road Traffic Act, Tax Office Fees & Driving Laws`
    : `${title} | ${siteName}`;

  // Use clean URLs for SEO (e.g., /offences instead of /#offences)
  const url = canonical || (page === 'home' ? baseUrl : `${baseUrl}/${page}`);

  // Get page-specific keywords or use default
  const pageKeywords = keywords || PAGE_SEO[page]?.keywords || 'Jamaica Road Traffic Act, tax office Jamaica, driving in Jamaica, Jamaica drivers guide, TAJ Jamaica, ITA Jamaica';

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={pageKeywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${baseUrl}${image}`} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_JM" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${baseUrl}${image}`} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow, max-video-preview:-1, max-image-preview:large, max-snippet:-1" />
      <meta name="geo.region" content="JM" />
      <meta name="geo.placename" content="Jamaica" />
    </Helmet>
  );
};

// ==================== STRUCTURED DATA COMPONENTS ====================

// Website Schema
export const WebsiteSchema = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: "Jamaica Driver's Guide",
    alternateName: ["JM Driver's Guide", "Jamaica Road Traffic Act Guide", "Jamaica Motorist Guide"],
    url: 'https://jamaicadriversguide.com',
    description: "Jamaica's most comprehensive guide to the Road Traffic Act, Tax Office fees, driving laws, traffic fines, and driver resources",
    inLanguage: 'en-JM',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://jamaicadriversguide.com/offences?search={search_term_string}'
      },
      'query-input': 'required name=search_term_string'
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

// Organization Schema
export const OrganizationSchema = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: "Jamaica Driver's Guide",
    alternateName: ['Jamaica Motorist Guide', 'JM Driver Guide'],
    url: 'https://jamaicadriversguide.com',
    logo: 'https://jamaicadriversguide.com/logo.png',
    description: "Jamaica's most comprehensive guide to the Road Traffic Act, Tax Office fees, driving laws, traffic fines, and driver resources",
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      areaServed: 'JM',
      availableLanguage: ['English']
    },
    knowsAbout: [
      'Jamaica Road Traffic Act',
      'Jamaica Tax Office vehicle fees',
      'Jamaica driving licence',
      'Jamaica traffic fines',
      'Jamaica road safety'
    ],
    sameAs: []
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

// FAQ Schema for Offences Page
export const FAQSchema = ({ faqs }) => {
  if (!faqs || faqs.length === 0) return null;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer
      }
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

// LocalBusiness Schema for Directory Listings
export const LocalBusinessSchema = ({ business, type }) => {
  if (!business) return null;

  const businessType = {
    lawyer: 'LegalService',
    insurance: 'InsuranceAgency',
    evaluator: 'AutomotiveBusiness',
    mechanic: 'AutoRepair',
    wrecker: 'AutoRepair',
    parts: 'AutoPartsStore',
    dealership: 'AutoDealer'
  };

  const schema = {
    '@context': 'https://schema.org',
    '@type': businessType[type] || 'LocalBusiness',
    name: business.name,
    description: business.description,
    telephone: business.phone,
    email: business.email,
    url: business.website,
    address: business.address ? {
      '@type': 'PostalAddress',
      addressLocality: business.parish,
      addressCountry: 'JM',
      streetAddress: business.address
    } : undefined,
    areaServed: business.parishes?.map(p => ({
      '@type': 'AdministrativeArea',
      name: p
    })) || [{ '@type': 'Country', name: 'Jamaica' }],
    aggregateRating: business.rating > 0 ? {
      '@type': 'AggregateRating',
      ratingValue: business.rating,
      reviewCount: business.review_count || 1
    } : undefined
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

// Breadcrumb Schema
export const BreadcrumbSchema = ({ items }) => {
  if (!items || items.length === 0) return null;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

// Article Schema for How-To Guides
export const ArticleSchema = ({ title, description, datePublished, dateModified }) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description: description,
    author: {
      '@type': 'Organization',
      name: "Jamaica Driver's Guide"
    },
    publisher: {
      '@type': 'Organization',
      name: "Jamaica Driver's Guide",
      logo: {
        '@type': 'ImageObject',
        url: 'https://jamaicadriversguide.com/logo.png'
      }
    },
    datePublished: datePublished || '2024-01-01',
    dateModified: dateModified || new Date().toISOString().split('T')[0]
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

// ItemList Schema for Offences List
export const OffencesListSchema = ({ offences, category }) => {
  if (!offences || offences.length === 0) return null;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: category ? `Jamaica Traffic Offences - ${category}` : 'Jamaica Traffic Offences',
    description: 'Complete list of traffic offences and fines under Jamaica Road Traffic Regulations 2022',
    numberOfItems: offences.length,
    itemListElement: offences.slice(0, 50).map((offence, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: offence.name || offence.title,
      description: offence.description,
      url: `https://jamaicadriversguide.com/#offence/${offence.id}`
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

// Government Service Schema for Official Information
export const GovernmentServiceSchema = ({ serviceName, description }) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'GovernmentService',
    name: serviceName || 'Jamaica Road Traffic Information',
    description: description || 'Information about Jamaica Road Traffic Regulations and driver services',
    serviceType: 'Road Traffic Information',
    provider: {
      '@type': 'GovernmentOrganization',
      name: 'Island Traffic Authority Jamaica',
      url: 'https://www.ita.gov.jm'
    },
    areaServed: {
      '@type': 'Country',
      name: 'Jamaica'
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

// HowTo Schema for Guides (Police Stop, Learner Driver)
export const HowToSchema = ({ name, description, steps, totalTime }) => {
  if (!steps || steps.length === 0) return null;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: name,
    description: description,
    totalTime: totalTime || 'PT10M',
    step: steps.map((step, index) => ({
      '@type': 'HowToStep',
      position: index + 1,
      name: step.name || `Step ${index + 1}`,
      text: step.text || step.description,
      url: step.url
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

// Table Schema for Fees and Demerit Points
export const TableSchema = ({ name, description, about }) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Table',
    name: name,
    description: description,
    about: {
      '@type': 'Thing',
      name: about || 'Jamaica Road Traffic Regulations'
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

// Software Application Schema for PWA
export const SoftwareApplicationSchema = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: "Jamaica Driver's Guide",
    operatingSystem: 'Web',
    applicationCategory: 'UtilitiesApplication',
    description: "Jamaica's complete guide to the Road Traffic Act. Check Tax Office fees, look up traffic fines, know your rights, find lawyers and insurance.",
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD'
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.8',
      ratingCount: '150',
      bestRating: '5',
      worstRating: '1'
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

// Service Area Schema for Service Providers
export const ServiceAreaSchema = ({ parishes }) => {
  if (!parishes || parishes.length === 0) return null;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Jamaica Driver Services Directory',
    description: 'Find traffic lawyers, insurance companies, and vehicle service providers across Jamaica',
    areaServed: parishes.map(parish => ({
      '@type': 'AdministrativeArea',
      name: parish
    })),
    serviceType: 'Directory Service'
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default SEO;
